import React, { useEffect, useState } from 'react';
import Persona from 'persona';
import { useHistory,useParams } from 'react-router-dom';
import "./CMSPageMobile.scss"
import { CmsCategoryAsyncAction,getCMSListData } from "../../features/CMS/cmsSlice";
import { useDispatch,useSelector } from "react-redux";

const CMSPageMobile = () => {
    const { type } = useParams();
    const dispatch = useDispatch()
    let catListSelector = useSelector(getCMSListData)
    catListSelector=catListSelector && catListSelector.data && catListSelector.data.content?catListSelector.data.content:"";
    const [textContent,setTextContent]=useState("");
    
    useEffect(() => {
        if(type){
            dispatch(CmsCategoryAsyncAction({slug:type}))
            setTextContent(catListSelector)
        }
    }, [dispatch])

    useEffect(() => {
       setTextContent(catListSelector);
    }, [catListSelector])

    return (
        <section className="webView-persona-block">
          <div className="inner-block-mobile" dangerouslySetInnerHTML={{ __html: textContent }} />
        </section>
    );
};

export default CMSPageMobile;
